<template>
  <v-app>
    <v-main>
      <Cookie />
      <cHeader />
      <div class="fixHeader"></div>
      <div style="">
        <router-view/>
      </div>
      <cFooter />
    </v-main>
  </v-app>
</template>

<style>
  .fixHeader {height: 150px;}
  @media handheld, only screen and (max-width: 600px) {}
  @media handheld, only screen and (max-width: 960px) {
    .fixHeader {height: 130px;}
  }
  @media handheld, only screen and (max-width: 1279px) {}
  @media handheld, only screen and (max-width: 1378px) {}
</style>
<script>
  import Cookie from '../src/components/cookie.vue';
  import { initConsentMode, registerScript, applyConsent } from '../public/ressources/script/cookieConsent.js';

  export default {
    name: 'App',
    components: {
      Cookie,
    },
    mounted() {
      // 1. Initialiser le Google Consent Mode (tout denied par défaut)
      initConsentMode();

      // 2. Enregistrer les scripts par catégorie
      //    Remplace les exemples ci-dessous par tes vrais scripts

      // --- PERFORMANCE ---
      // Exemple : Google Analytics
      // registerScript('Performance', () => {
      //   const script = document.createElement('script')
      //   script.src = 'https://www.googletagmanager.com/gtag/js?id=G-XXXXXXX'
      //   script.async = true
      //   document.head.appendChild(script)
      //   script.onload = () => {
      //     window.gtag('js', new Date())
      //     window.gtag('config', 'G-XXXXXXX')
      //   }
      // })
      // --- PERFORMANCE : Google Tag Manager + Google Analytics ---
      registerScript('Performance', () => {
        // Google Tag Manager (GTM-PS9XTZC)
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-PS9XTZC');
 
        // Google Analytics (UA-3192388-2)
        var gaScript = document.createElement('script');
        gaScript.async = true;
        gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=UA-3192388-2';
        document.head.appendChild(gaScript);
        gaScript.onload = function() {
          window.dataLayer = window.dataLayer || [];
          function gtag(){ window.dataLayer.push(arguments); }
          window.gtag = gtag;
          gtag('js', new Date());
          gtag('config', 'UA-3192388-2');
        };
      })

      // --- PERSONNALISATION ---
      // Exemple : Chat widget, Hotjar, etc.
      // registerScript('Personalization', () => {
      //   // Charger ton script de personnalisation
      // })

      // --- PUBLICITÉ ---
      // Exemple : Facebook Pixel
      // registerScript('Advertising', () => {
      //   !function(f,b,e,v,n,t,s){...}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js')
      //   fbq('init', 'XXXXXXXXXX')
      //   fbq('track', 'PageView')
      // })

      // 3. Appliquer le consentement sauvegardé (charge les scripts déjà autorisés)
      applyConsent();
    }
  }
</script>
